import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { useAskEmma } from "../../../contexts/AskEmmaContext";
import { convertToBase64 } from "../../../utils/Utils";

import documentService from "../../../services/DocumentService";

export const useFileUpload = () => {
    const [uploadProgress, setUploadProgress] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const fileToUploadRef = useRef(null);
    const [showImgPreview, setShowImgPreview] = useState(false);

    const { sendMessage } = useAskEmma();

    const handleFileUpload = (event) => {
        const file = event.target.files?.[0];
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/bmp'];
        if (file && allowedTypes.includes(file.type)) {
            setErrorMessage("");

            const blob = new Blob([file], { type: file.type });
            const url = URL.createObjectURL(blob);
            fileToUploadRef.current = url;
            setShowImgPreview(true);
        } else {
            toast.error('Invalid file type. Please upload a PDF, JPG, JPEG, PNG, or BMP file.');
            setErrorMessage('Invalid file type. Please upload a PDF, JPG, JPEG, PNG, or BMP file.');
        }
    };

    const handleCameraCapture = async () => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            toast.error('Camera API is not supported in this browser.');
            return;
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            const video = document.createElement('video');
            video.srcObject = stream;
            video.play();

            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            canvas.toBlob(blob => {
                const file = new File([blob], 'captured-image.png', { type: 'image/png' });
                stream.getTracks().forEach(track => track.stop());
            });
        } catch (error) {
            console.error('Error accessing camera:', error);
            toast.error('Error accessing camera: ' + error.message);
        }
    };

    // Refactored handleSendMessage function
    const handleSendMessage = async (userMessage, fileUrlToUpload, cb) => {
        let fileUrl = null;
        // If there's a file to upload, handle file upload
        if (fileUrlToUpload) {
            try {
                //From url convert to base64


                // fileUrlToUpload to blob
                const imageFetch = await fetch(fileUrlToUpload);
                const blob = await imageFetch.blob();
                const base64Data = await convertToBase64(blob);

                // Fetch file upload endpoint
                const response = await documentService.base64FileToUrl({ Base64Data: base64Data });
                // const response = await fetch('https://stgvaapi.injurycloud.com/ReportApi/UploadFileToCdn', {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json'
                //     },
                //     body: JSON.stringify({ Base64Data: base64Data }),
                //     onUploadProgress: (event) => {
                //         if (event.lengthComputable) {
                //             const percentComplete = (event.loaded / event.total) * 100;
                //             setUploadProgress(percentComplete); // Update progress
                //         }
                //     }
                // });
                console.log('response', response);



                if (!response.success) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || `HTTP error ${response.status}`);
                }

                fileUrl = response.data?.Message?.FileUrl; // Get the uploaded file URL
                console.log('File uploaded successfully:', fileUrl);

            } catch (error) {
                console.error('Error during file upload:', error);
                setErrorMessage(`Error uploading file: ${error.message}`);
            } finally {
                setUploadProgress(0); // Reset upload progress
            }
        }

        // If there's a user message or file URL, send it
        if (userMessage || fileUrl) {
            // Call sendMessage or any other method for dispatching the message
            sendMessage(userMessage, fileUrl); // Ensure sendMessage is defined elsewhere or replace with the actual method
            if (cb) {
                cb();
            }
        }
    };

    return {
        handleFileUpload,
        handleCameraCapture,
        handleSendMessage,
        uploadProgress,
        errorMessage,
        fileToUploadRef, showImgPreview, setShowImgPreview
    };
};
